<!-- Breadcrumb -->
<div class="mb-[25px] md:flex items-center justify-between">
    <h5 class="!mb-0">
        Radar Charts
    </h5>
    <ol class="breadcrumb mt-[12px] md:mt-0">
        <li class="breadcrumb-item inline-block relative text-sm mx-[13px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0">
            <a routerLink="/dashboard" class="inline-block relative ltr:pl-[22px] rtl:pr-[22px] transition-all hover:text-primary-500">
                <i class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-lg -mt-px text-primary-500 top-1/2 -translate-y-1/2">
                    home
                </i>
                Dashboard
            </a>
        </li>
        <li class="breadcrumb-item inline-block relative text-sm mx-[13px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0">
            ApexCharts
        </li>
        <li class="breadcrumb-item inline-block relative text-sm mx-[13px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0">
            Radar Charts
        </li>
    </ol>
</div>

<!-- Radar Charts -->
<div class="grid grid-cols-1 lg:grid-cols-2 gap-[25px] mb-[25px]">

    <!-- Basic Radar Chart -->
    <app-basic-radar-chart />

    <!-- Multiple Radar Chart -->
    <app-multiple-radar-chart />

    <!-- Polygon Radar Chart -->
    <app-polygon-radar-chart />
    
</div>